import { FloorType } from "../entities"

export function getOrderedFloorList(
    tmpFloorList: FloorType[]
) {
    // ソートした施設一覧の作成
    const sortedFloorList = tmpFloorList?.sort((a, b) => a.index - b.index)
    return sortedFloorList
}